'use client'

import { InteractiveVisual } from '@/components/interactive/registry'
import { RichText } from '@/components/shared/rich-text'
import { SectionHeader } from '@/components/shared/section-header'
import { fadeInBlur } from '@/lib/animations'
import { BlokProps } from '@/lib/types'
import { PageHeroStoryblok } from '@/lib/types/component-types-sb'
import { storyblokEditable } from '@storyblok/react/rsc'
import { motion } from 'motion/react'
import { StoryblokImage } from '../shared/storyblok-image'

export function PageHero({ blok }: BlokProps<PageHeroStoryblok>) {
  return (
    <div
      className="relative overflow-hidden py-16"
      {...storyblokEditable(blok)}
    >
      <div className="page-container">
        <div className="space-y-5">
          <motion.div
            {...fadeInBlur}
            transition={{ duration: 0.4 }}
          >
            <SectionHeader
              preTitle={blok.descriptorTitle}
              icon={blok.descriptorIcon}
              layout="center"
            />
          </motion.div>
          <div className="space-y-2.5">
            <motion.h1
              {...fadeInBlur}
              transition={{ delay: 0.2 }}
              className="tracking-hero-title text-accent-foreground mx-auto max-w-[780px] text-center text-3xl font-semibold lg:text-5xl"
            >
              {blok.title}
            </motion.h1>
            <motion.div
              {...fadeInBlur}
              transition={{ delay: 0.3 }}
            >
              <RichText
                className="mx-auto max-w-[580px] text-center text-lg"
                content={blok.content}
              ></RichText>
            </motion.div>
          </div>
          {(blok.visualAsset || blok.visual) && (
            <motion.div
              {...fadeInBlur}
              transition={{ delay: 0.5 }}
              className="relative z-20 mx-auto mt-9 mb-0 lg:-mb-20 lg:max-w-[1200px]"
            >
              {blok.visualAsset?.filename && (
                <StoryblokImage
                  image={blok.visualAsset}
                  cropWidth={1400}
                  cropHeight={800}
                  className="h-auto max-h-[400px] w-[800px] max-w-none overflow-hidden rounded-lg object-cover object-center lg:max-h-[600px] lg:w-full"
                  priority
                />
              )}
              {blok.visual && <InteractiveVisual componentId={blok.visual} />}
            </motion.div>
          )}
          <motion.div
            className="bg-brand absolute -bottom-[180px] left-1/2 h-[400px] w-[700px] -translate-x-1/2 rounded-[600px] blur-[80px] lg:-bottom-[430px] lg:h-[870px] lg:w-[1550px] lg:rounded-[1550px] lg:blur-[150px]"
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 0.2, y: 0 }}
            transition={{ ease: 'easeInOut', duration: 0.4, delay: 0.5 }}
          ></motion.div>
        </div>
      </div>
    </div>
  )
}
